var cov_77l56rnpq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/cleanProps.ts",
      hash = "1f951bf9e635d1f89e5e68ffa8c235d2800c6267",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/cleanProps.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 24
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 33,
          column: 4
        }
      },
      "2": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 39
        }
      },
      "3": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 32,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "cleanProps",
        decl: {
          start: {
            line: 30,
            column: 24
          },
          end: {
            line: 30,
            column: 34
          }
        },
        loc: {
          start: {
            line: 30,
            column: 64
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 22
          },
          end: {
            line: 31,
            column: 23
          }
        },
        loc: {
          start: {
            line: 31,
            column: 31
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 31
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 32,
            column: 19
          }
        },
        loc: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 32,
            column: 38
          }
        },
        line: 32
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import immer from 'immer';
var names = (cov_77l56rnpq.s[0]++, ['delay', 'onDatumBind', 'rules', 'formDatum', 'forceChange', 'trim', 'beforeChange', 'validateHook', 'innerFormNamePath', 'fieldSetValidate', 'combineRules', 'popoverProps', 'inputFocus', 'placeTitle', 'cancelChange', 'integerLimit', 'autoSelect', 'autoFix', 'numType']);
/**
 * delete some props if needed, will not modify the pass argument
 * @param props
 * @returns {Produced<*, *>}
 */

export default function cleanProps(props) {
  cov_77l56rnpq.f[0]++;
  cov_77l56rnpq.s[1]++;
  return immer(props, function (draft) {
    cov_77l56rnpq.f[1]++;
    cov_77l56rnpq.s[2]++;
    names.forEach(function (p) {
      cov_77l56rnpq.f[2]++;
      cov_77l56rnpq.s[3]++;
      return delete draft[p];
    });
  });
}